<template>
  <div id="nav">
    <top-panel />
  </div>
  <div class="pt-6">
    <router-view/>
    <upload-passport/>
  </div>
  <warning-msg />
  <footer class="pt-3 text-muted text-center">
    <p class="m-0">Версия {{ version }}</p>
    <p class="copyright text-muted text-center m-0">
      Copyright &copy; ООО ФРЕШБЕРРИ 2022
    </p>
  </footer>
</template>


<script>
import TopPanel from "@/components/TopPanel.vue";
import UploadPassport from "@/components/UploadPassport.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { onMounted, onBeforeUpdate, onBeforeMount, computed } from "vue";
import {version} from '../package.json'
import useCommonMixin from '@/components/commonMixin.js'
import WarningMsg from "@/components/WarningMsg.vue";

export default {
  components: {
    TopPanel,
    UploadPassport,
    WarningMsg,
  },
  setup() {
    const store = useStore();
    const router = useRouter()
    useCommonMixin()
    const { jwtAccessValid } = useCommonMixin()

    const inspectToken = async () => {
      let status = await store.dispatch("inspectToken");
      if (status) {
        await store.dispatch("FETCHuserProfile", { userId: null, phone: null });
        await store.dispatch("FETCHuserBalance", store.getters.userProfile._id);
      } else {
        router.push({name: "login"})
      }
    };
    onBeforeMount(inspectToken);
    onBeforeUpdate(inspectToken);
    return {
      version,
      userProfile: computed(() => store.getters.userProfile),
      userName: computed(() => store.getters.userName),
      jwtAccessValid,
    }
  },
};
</script>


<style>
.pt-6 {
  padding-top: 4rem !important;
}
.berry {
  font-size: 1.0rem !important;
  width: 100%;
}

.deliverer {
  font-size: 1.2rem !important;
  width: 100%;
}

.summ {
  font-size: 3rem;
  font-weight: 1bold;
}

.input-price {
  min-height: 3rem !important;
  font-size: 2rem !important;
  padding-top: 0rem !important;
  padding-bottom: 0rem !important;
  line-height: 1rem !important;
}

.vertical-alignment-helper {
  display: table;
  height: 100%;
  pointer-events: none; /* This makes sure that we can still click outside of the modal to close it */
  width: 100%;
}
.vertical-align-center {
  /* To center vertically */
  display: table-cell;
  vertical-align: middle;
  pointer-events: none;
}
.sticky {
  position: sticky;
  top: 70px;
  z-index: 100;
  background-color: white;
}

.main-content {
  z-index: 0;
}
</style>
